<script lang="ts">
	import type { Snippet } from "svelte";
	import type { HTMLSelectAttributes } from "svelte/elements";

	let {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		value = $bindable(),
		/* eslint-disable prefer-const */
		options,
		...rest
		/* eslint-enable prefer-const */
	}: HTMLSelectAttributes & { options: Snippet } = $props();
</script>

<!--bg-white rounded-full py-3 px-4 border-r-8 border-white mb-4 lg:mb-6-->

<select
	{...rest}
	bind:value
	class={[
		"bg-white rounded-full py-3 px-4 border-r-8 text-black border-white [&:user-invalid]:outline-primary transition-[outline,text] duration-300 focus:outline-grey-700 focus:[&:user-invalid]:outline-grey-700 outline-transparent outline-2 outline outline-offset-0",
		rest.class,
	]}
>
	{@render options()}
</select>
